export class WebOrderMinimumValueSetup{
    refNo:number;
    orderMinValue:number;
    allowMinValue:boolean;
}